export default "__VITE_ASSET__CVo8af0d__"